import { ArrowLeftIcon } from "@heroicons/react/outline";
import { LoadingModal } from "Component/LoadingModal";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { ROUTES } from "Route/ConstantRoute";
import { EncryptStorage } from "encrypt-storage";
import { handleError } from "Helper";
import { latlongIndonesia } from "Assets/other/dummyData/latlongIndonesia";

function UpdateOperationPolice() {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const navigate = useNavigate();
  const location = useLocation();
  const argumentData = location.state;
  const [uuid] = useState(argumentData?.id || "");
  const [isLoading, setIsLoading] = useState(false);
  const [namaOperasi, setNamaOperasi] = useState(
    argumentData?.operation_name || ""
  );
  const [kodeOperasi, setKodeOperasi] = useState(
    argumentData?.operation_code || ""
  );
  const [operasiStartDate, setOperasiStartDate] = useState(
    `${argumentData?.operation_start_date}` || ""
  );
  const [operasiEndDate, setOperasiEndDate] = useState(
    `${argumentData?.operation_end_date}` || ""
  );
  const [totalPersonil, setTotalPersonil] = useState(
    argumentData?.operation_total_personnel || ""
  );
  const [patrolArea, setPatrolArea] = useState(
    argumentData?.operation_patrol_area || ""
  );
  const [purpose, setPurpose] = useState(argumentData?.operation_purpose || "");
  const [supervisorName, setSupervisorName] = useState(
    argumentData?.operation_supervisor_name || ""
  );
  const [organizationId, setOrganizationId] = useState(
    argumentData?.operation_organization_id || ""
  );
  const [operationStatusId, setOperationStatusId] = useState(
    argumentData?.operation_status_id || ""
  );
  const [operationCategoryName, setOperationCategoryName] = useState(
    argumentData?.operation_kategori_id || ""
  );
  const [dataKategoriOperasi, setDataKategoriOperasi] = useState([]);
  const [dataOperationStatus, setDataOperationStatus] = useState([]);
  const [dataOrganization, setDataOrganization] = useState([]);

  const [selectedProvince, setSelectedProvince] = useState(
    argumentData?.name || null
  );
  const userLatitude = Number(argumentData?.latitude);
  const userLongitude = Number(argumentData?.longitude);

  const result = latlongIndonesia.find(
    (prov) => prov.latitude === userLatitude && prov.longitude === userLongitude
  );
  console.log(result, "result");
  // ==================== Default ==================== //
  const goBack = () => {
    navigate(ROUTES.management_data.OperationPolice.operation_police_home);
  };
  const handleWarning = (message) => {
    Notify.warning({
      title: "Peringatan",
      description: message,
    });
  };
  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  const getDataOperationStatus = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().get(`/operation-status/get-list`);
      const filterFlagData = response.data?.data.filter(
        (item) => item.flag_active_operation_status === true
      );
      setDataOperationStatus(filterFlagData);
      getDataOrganisasi();
    } catch (err) {
      setDataOperationStatus([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  const getDataOrganisasi = async () => {
    try {
      const paramPage = `page=0`;
      const paramSize = `size=999`;
      const response = await fetchApi().get(
        `/organization/get-list?${paramPage}&${paramSize}`
      );
      setDataOrganization(response.data?.data);
      setIsLoading(false);
    } catch (err) {
      setDataOrganization([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataKategoriOperasi = async () => {
    try {
      const response = await fetchApi().get(`/operation-kategori/get-list`);
      setDataKategoriOperasi(response.data?.data || []);
      setIsLoading(false);
    } catch (err) {
      setDataKategoriOperasi([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  // ==================== Default ==================== //

  const updateData = async () => {
    try {
      setIsLoading(true);
      const reqBody = {
        operation_code: kodeOperasi,
        operation_name: namaOperasi,
        operation_start_date: moment(operasiStartDate).format("YYYY-MM-DD"),
        operation_end_date: moment(operasiEndDate).format("YYYY-MM-DD"),
        operation_total_personnel: parseInt(totalPersonil, 10),
        operation_patrol_area: patrolArea,
        operation_purpose: purpose,
        operation_supervisor_name: supervisorName,
        operation_organization_id: organizationId,
        operation_status_id: operationStatusId,
        operation_kategori_id: operationCategoryName,
        latitude: selectedProvince?.latitude,
        longitude: selectedProvince?.longitude,
      };
      const response = await fetchApi().put(
        `/operation/update/${uuid}`,
        reqBody
      );
      setIsLoading(false);
      handleSuccess(response.data?.message);
      goBack();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const tanggalMulai = moment(operasiStartDate).format("YYYY-MM-DD");
    const tanggalBerakhir = moment(operasiEndDate).format("YYYY-MM-DD");
    // Validasi tanggal
    if (moment(tanggalBerakhir).isBefore(tanggalMulai)) {
      handleWarning("Tanggal berakhir tidak boleh sebelum tanggal mulai!");
    } else if (moment(tanggalBerakhir).isSame(tanggalMulai)) {
      handleWarning("Tanggal berakhir sama dengan tanggal mulai.");
    } else {
      updateData();
    }
  };

  useEffect(() => {
    getDataOperationStatus();
    getDataKategoriOperasi();
    setSelectedProvince(result);
  }, []);

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Ubah Data Operasi Polisi
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="rounded-2xl border-solid border-gray-300 border shadow-xl bg-white p-6">
          <div className="flex justify-between items-center px-5 w-full">
            <div className="w-2/4">
              <button
                type="submit"
                onClick={goBack}
                disabled={isLoading}
                className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                <ArrowLeftIcon className="h-6 w-auto pr-2" />
                Kembali
              </button>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="w-full">
              <label
                htmlFor="operation_supervisor_name"
                className="flex block text-sm font-medium leading-6"
              >
                Nama Penanggung Jawab Operasi
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="operation_supervisor_name"
                  name="operation_supervisor_name"
                  type="text"
                  disabled={isLoading}
                  value={supervisorName}
                  placeholder="Masukkan Nama Penanggung Jawab"
                  onChange={(e) => setSupervisorName(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center py-5 px-5 w-full gap-4">
            <div className="w-full md:w-1/3">
              <label
                htmlFor="operation_name"
                className="flex block text-sm font-medium leading-6"
              >
                Nama Operasi
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="operation_name"
                  name="operation_name"
                  type="text"
                  disabled={isLoading}
                  value={namaOperasi}
                  placeholder="Masukkan Nama Operasi"
                  onChange={(e) => setNamaOperasi(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="w-full md:w-1/3">
              <label
                htmlFor="operation_code"
                className="flex block text-sm font-medium leading-6"
              >
                Kode Operasi
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="operation_code"
                  name="operation_code"
                  type="text"
                  disabled={isLoading}
                  placeholder="Masukkan Kode Operasi"
                  value={kodeOperasi}
                  onChange={(e) => setKodeOperasi(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="w-full md:w-1/3">
              <label
                htmlFor="operationCategoryName"
                className="flex block text-sm font-medium leading-6"
              >
                Kategori Operasi
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="operationCategoryName"
                    name="operationCategoryName"
                    required
                    value={operationCategoryName}
                    disabled={isLoading}
                    onChange={(e) => {
                      setOperationCategoryName(e.target.value);
                    }}
                    className="appearance-none capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                  >
                    <option value="" disabled>
                      Pilih Kategori Operasi
                    </option>
                    {dataKategoriOperasi.map((item) => (
                      <option key={item.id} value={item.uuid}>
                        {item.operation_kategori_name}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-between items-center py-5 px-5 w-full gap-2 ">
            {/* Pilih Lokasi */}
            <div className="mb-4 sm:mb-0 w-full sm:w-1/3">
              <label
                htmlFor="province"
                className="block text-sm font-medium leading-6"
              >
                Pilih Lokasi
              </label>
              <div className="mt-2">
                <select
                  id="province"
                  name="province"
                  value={selectedProvince ? selectedProvince.name : ""}
                  onChange={(e) => {
                    const province = latlongIndonesia.find(
                      (p) => p.name === e.target.value
                    );
                    setSelectedProvince(province || null);
                  }}
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm"
                >
                  <option value="">-- Pilih Provinsi --</option>
                  {latlongIndonesia.map((province) => (
                    <option key={province.name} value={province.name}>
                      {province.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Latitude & Longitude */}

            {/* Latitude */}
            <div className="mb-4 sm:mb-0 sm:mr-4 w-full sm:w-1/3">
              <label
                htmlFor="latitude_device"
                className="block text-sm font-medium leading-6"
              >
                Latitude Lokasi
              </label>
              <div className="mt-2">
                <input
                  id="latitude_device"
                  name="latitude_device"
                  type="text"
                  value={selectedProvince ? selectedProvince.latitude : ""}
                  disabled
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm"
                />
              </div>
            </div>

            {/* Longitude */}
            <div className="w-full sm:w-1/3">
              <label
                htmlFor="longitude_device"
                className="block text-sm font-medium leading-6"
              >
                Longitude Lokasi
              </label>
              <div className="mt-2">
                <input
                  id="longitude_device"
                  name="longitude_device"
                  type="text"
                  value={selectedProvince ? selectedProvince.longitude : ""}
                  disabled
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="operation_start_date"
                className="flex block text-sm font-medium leading-6"
              >
                Tanggal Operasi Dimulai
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="operation_start_date"
                  name="operation_start_date"
                  type="date"
                  placeholder="DD-MM-YYYY"
                  disabled={isLoading}
                  value={operasiStartDate}
                  onChange={(e) => setOperasiStartDate(e.target.value)}
                  required
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className="mb-2 w-2/4">
              <label
                htmlFor="operation_end_date"
                className="flex block text-sm font-medium leading-6"
              >
                Tanggal Operasi Berakhir
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="operation_end_date"
                  name="operation_end_date"
                  type="date"
                  placeholder="DD-MM-YYYY"
                  disabled={isLoading}
                  value={operasiEndDate}
                  onChange={(e) => setOperasiEndDate(e.target.value)}
                  required
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="operation_total_personnel"
                className="flex block text-sm font-medium leading-6"
              >
                Jumlah Personil Terlibat
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="operation_total_personnel"
                  name="operation_total_personnel"
                  type="number"
                  disabled={isLoading}
                  value={totalPersonil}
                  placeholder="Masukkan Jumlah Personil"
                  onChange={(e) => setTotalPersonil(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="mb-2 w-2/4">
              <label
                htmlFor="operation_patrol_area"
                className="flex block text-sm font-medium leading-6"
              >
                Area Operasi
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="operation_patrol_area"
                  name="operation_patrol_area"
                  type="text"
                  disabled={isLoading}
                  placeholder="Masukkan Area Operasi"
                  value={patrolArea}
                  onChange={(e) => setPatrolArea(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="status_operation"
                className="flex block text-sm font-medium leading-6"
              >
                Status Operasi
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="status_operation"
                    name="status_operation"
                    required
                    disabled={isLoading}
                    value={operationStatusId}
                    onChange={(e) => {
                      setOperationStatusId(e.target.value);
                    }}
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Status Operasi
                    </option>
                    {dataOperationStatus.map((item) => (
                      <option value={item.id}>
                        {item.operation_status_name}
                      </option>
                    ))}
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-2 w-2/4">
              <label
                htmlFor="operation_organization_id"
                className="flex block text-sm font-medium leading-6"
              >
                Organisasi Penanggung Jawab
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="operation_organization_id"
                    name="operation_organization_id"
                    required
                    value={organizationId}
                    disabled={yuridiksi_user_code !== "N" ? true : false}
                    onChange={(e) => setOrganizationId(e.target.value)}
                    className={`${
                      yuridiksi_user_code !== "N" ? "bg-zinc-100" : ""
                    } h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Organisasi
                    </option>
                    {dataOrganization.map((item) => (
                      <option value={item.id}>{item.organization_name}</option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-full">
              <label
                htmlFor="operation_purpose"
                className="flex block text-sm font-medium leading-6"
              >
                Deskripsi Operasi
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <textarea
                  id="operation_purpose"
                  name="operation_purpose"
                  type="text"
                  disabled={isLoading}
                  value={purpose}
                  placeholder="Masukkan Deskripsi Operasi"
                  onChange={(e) => setPurpose(e.target.value)}
                  required
                  className="h-28 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end mr-5">
            <button
              type="submit"
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Simpan
            </button>
          </div>
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}

export default UpdateOperationPolice;
